import { render, staticRenderFns } from "./Devoluciones.vue?vue&type=template&id=78f48fdc&scoped=true"
import script from "./Devoluciones.vue?vue&type=script&lang=js"
export * from "./Devoluciones.vue?vue&type=script&lang=js"
import style0 from "./Devoluciones.vue?vue&type=style&index=0&id=78f48fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f48fdc",
  null
  
)

export default component.exports